import { BaseModel } from "../../../ensue-react-system/utilities/base-model";
import { PlayerPositionEnum } from "../../enums/match-player-position-enum";
import { FootballPlayer } from "./football-player";
import { FootballTeam } from "./football-team";
import { IFootballCompetitionPlayerStat } from "./interface/i-football-competition-stat";
import { IFootballPlayer } from "./interface/i-football-player";
import { IFootballTeam } from "./interface/i-football-team";

export class FootballCompetitionPlayerStat
  extends BaseModel
  implements IFootballCompetitionPlayerStat
{
  public position: PlayerPositionEnum = PlayerPositionEnum.Defender;
  public player: IFootballPlayer = new FootballPlayer();
  public value: string = "";
  public team: IFootballTeam = new FootballTeam();
  public constructor(props: { [key: string]: any } | undefined = undefined) {
    super(props);
    this.__init(props);
  }
}
